<template>
  <div class="layout-main">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店长: </div>
            <ul class="item-list">
              <li @click="selectitem('user_id', item.id)" v-for="(item, index) in userList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.username}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店铺: </div>
            <ul class="item-list">
              <li @click="selectitem('store_id', item.id)" v-for="(item, index) in storeList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          
          <li class="list-group-item">
            <div class="item-label">跟进人员: </div>
            <ul class="item-list">
              <li @click="selectitem('track_user_id', item.id)" v-for="(item, index) in traceUser" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.username}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">状态: </div>
            <ul class="item-list">
              <li @click="selectitem('status', item.value)" v-for="(item, index) in statuses" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">搜索: </div>
            <Input v-model="searchval" style="width: 500px" >
                    <Select v-model="searchfield" slot="prepend" style="width: 80px">
                        <Option value="ordersn">订单号</Option>
                    </Select>
                    <Button @click="request" slot="append" icon="ios-search"></Button>
                </Input>
           
          </li>
        </ul>
      </div>
      <div class="tools">
        <Button @click="request" style="background: #1a242f" type="primary" icon="ios-refresh"></Button>
        &nbsp;
        <UploadTool @uploadback="uploadback"></UploadTool>&nbsp;
        <Button @click="tempDown">模板下载</Button>&nbsp;
        <Button @click="trackUserModal = true">跟进人员</Button>
      </div>
      <Divider dashed />
      <Table ref="selection" @on-selection-change="tableSelectionChange" :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="status_text">
          <Select @on-change="(val)=>selectStatus(val, row.id)" v-model="row.status" style="width:200px">
              <Option v-for="item in statuses" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="ratings">
          <Input type="text" v-model="rowEdit.editRatings" v-if="rowEdit.editIndex === index" />
          <span v-else><font color="#ff0000">{{row.ratings}}</font></span>
        </template>
        <template slot-scope="{ row, index }" slot="remark">
          <Input type="text" v-model="rowEdit.editRemark" v-if="rowEdit.editIndex === index" />
          <span v-else>{{ row.remark }}</span>
        </template>
        <template slot-scope="{ row }" slot="trackuser">
          <strong>{{ row.user ? row.user.username : '' }}</strong>
        </template>
        <template slot-scope="{ row }" slot="store">
          <strong>{{ row.store ? row.store.name : '' }}</strong>
        </template>
        <template slot-scope="{ row }" slot="review_content">
          <span style="cursor: pointer;" @click="previewImg(row.review_content)" v-if="(row.review_content.indexOf('.png') > -1)"><img style="max-height: 50px;" :src="row.review_content"></span>
          <span v-else>{{row.review_content}}</span>
        </template>
          
        <template slot-scope="{ row, index }" slot="action">
          
          <div v-if="rowEdit.editIndex === index">
            <Button @click="handleSave(index)">保存</Button>
            <Button @click="rowEdit.editIndex = -1">取消</Button>
          </div>
          <div v-else>
            <Icon style="cursor: pointer;" size="20" title="备注" @click="handleEdit(row, index)" type="md-create" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="打开聊天" @click="openSession(row)" type="md-ionitron" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="客户资料" @click="buyer_info(row)" type="ios-copy" />&nbsp;
            <Icon style="cursor: pointer;" size="20" title="删除" @click="del(row)" type="md-trash" />
          </div>
        </template>
      </Table>
      <div class="page-wrap">            
        <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>

<Modal
    v-model="preview.previewModal"
    :footer-hide="true"
    width="600"
    >
  <img style="max-width: 500px;" :src="preview.previewImgurl">
</Modal>
<!-- 跟进人员modal -->
<Modal
    v-model="trackUserModal"
    title="选择跟进用户"
    @on-ok="setOperater"
    @on-cancel="trackUserModal = false">
    <Select v-model="track_user_id" style="width:200px">
        <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.username }}</Option>
    </Select>
</Modal>
</div>
</template>
<script>
import conf from "@/views/im/conf";
import UploadTool from "./uploadTool.vue";
import RequestUtils from "@/utils/RequestUtils";

const { downloadFile } = require("@/utils/ChatUtils");

export default {
  components: {
    UploadTool
  },

  data() {
    return {
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'ordersn',
      searchval: '',
      trackUserModal: false,
      addRemarkModal: false,
      remarkList: [],
      selectData: {},
      track_user_id: '',
      tableSelection: [],
      userList: [],
      traceUser: [],
      storeList: [],
      rowEdit: {
        editIndex: -1,  // 当前聚焦的输入框的行数
        editRatings: '',
        editRemark: '',
      },
      filter: {
        connector: 'lazada',
        store_id: 0,
        type: 0,
        track_user_id: 0,
        status: 0
      },      
      statuses: [
        {name: '待处理', value: 0, active: true},
        {name: '已完成', value: 1, active: false},
      ],
      remarkFormItem: {
        id: '',
        remark: ''
      },
      preview: {
        previewModal: false,
        previewImgurl: ''
      },
      columns: [
          {
              type: 'selection',
              width: 60,
              align: 'center'
          },
          {
              title: '订单号',
              key: 'ordersn',
              width: 170
          },
          {
              title: '店铺',
              slot: 'store'
          },
          {
              title: '买家电话',
              key: 'buyer_phone'
          },
          {
              title: '评分',
              slot: 'ratings',
          },
          {
              title: '评价内容',
              slot: 'review_content'
          },
          {
              title: '备注',
              slot: 'remark'
          },
          {
              title: '跟进人员',
              slot: 'trackuser'
          },
          {
              title: '状态',
              slot: 'status_text'
          },
          {
              title: '创建时间',
              key: 'create_time_text'
          },
          
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },
  computed: {
    stores: {
      get: function() {
        return this.$store.state.storeOpt;
      }
    }
  },
  methods: {
    // 店铺列表
    getStoreList () {
      let self = this;
      let param = new FormData();
      param.set("connector", this.filter.connector);
      if (this.filter.country) {
        param.set("country", this.filter.country);
      }
      if (this.filter.user_id) {
        param.set("ids", this.filter.user_id);
      }
      RequestUtils.request(conf.getStoreByUid(), param)
      .then(function (data) {
        self.storeList = data
        self.storeList.unshift({
          'id': 0,
          'name': '全部',
          'active': true
        })
      })
    },
    getUserList () {
      this.userList = JSON.parse(JSON.stringify(this.$store.state.childUser));
      this.userList.unshift({
        'id': 0,
        'username': '全部',
        'active': true
      })
    },
    getTraceUser () {
      this.traceUser = JSON.parse(JSON.stringify(this.$store.state.childUser));
      this.traceUser.unshift({
        'id': 0,
        'username': '全部',
        'active': true
      })
    },
    // 导入数据
    uploadback(data) {
      let param = new FormData();
      param.set("file", data.upload_path );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.reviewImport(), param)
      .then(() => {            
        this.$Message.success('导入成功!');
        this.request();
      })
    },
    // 行编辑
    handleEdit (row, index) {
      this.rowEdit.editRatings = row.ratings;
      this.rowEdit.editRemark = row.remark;
      this.rowEdit.editIndex = index;
    },
    // 行编辑保存
    handleSave (index) {
      let param = new FormData();
      param.set("id", this.data[index].id );
      param.set("remark", this.rowEdit.editRemark );
      param.set("ratings", this.rowEdit.editRatings );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.reviewEdit(), param)
      .then(() => {                  
        this.data[index].remark = this.rowEdit.editRemark;
        this.data[index].ratings = this.rowEdit.editRatings;
        this.rowEdit.editIndex = -1;
      })
    },
    // 选中表格选项
    tableSelectionChange(selection) {
      this.tableSelection = selection;
    },
    // table 选中的id
    tableSelectionId() {
      let ids = new Array();
      for (let i=0; i<this.tableSelection.length; i++) {
        ids.push(this.tableSelection[i].id);
      }
      return ids;
    },
    selectitem (key, value) {
      if (key == 'store_id') {
        for (let i=0; i<this.storeList.length; i++) {
          if (this.storeList[i].id == value) {
            this.storeList[i].active = true;
          } else {
            this.storeList[i].active = false;            
          }
        }
      } else if (key == 'track_user_id') {
        for (let i=0; i<this.traceUser.length; i++) {
          if (this.traceUser[i].id == value) {
            this.traceUser[i].active = true;
          } else {
            this.traceUser[i].active = false;
          }
        }
      } else if (key == 'user_id') {
        for (let i=0; i<this.userList.length; i++) {
          if (this.userList[i].id == value) {
            this.userList[i].active = true;
          } else {
            this.userList[i].active = false;
          }
        }
        this.filter[key] = value;
        this.getStoreList();
      } else if (key == 'status') {
        for (let i=0; i<this.statuses.length; i++) {
          if (this.statuses[i].value == value) {
            this.statuses[i].active = true;
          } else {
            this.statuses[i].active = false;
          }
        }
      }
      this.filter[key] = value;
      this.request();
    },
    selectStatus(value, id) {
      let self = this;
      let param = new FormData();
      param.set("id", id );
      param.set('status', value );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.setReviewStatus(), param)
      .then(() => {            
        self.$Message.success('设置成功!');
        self.request();
      })
    },
    switchPage (index) {
      this.data = [];
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("connector", this.filter.connector );
      param.set('status', this.filter.status);

      if (this.filter.store_id) {      
        param.set("store_id", this.filter.store_id );
      }
      if (this.filter.type) {
        param.set('type', this.filter.type);
      }
      if (this.filter.track_user_id) {
        param.set('track_user_id', this.filter.track_user_id);
      }
      if (this.filter.user_id) {
        param.set('user_id', this.filter.user_id);
      }
      if (this.searchval) {
        param.set(this.searchfield, this.searchval);
      }

      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getReviewList(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        self.loading = false;
      })
    },
    showAddRemarkModal(item) {
      this.addRemarkModal = true;
      this.remarkFormItem.id = item.id;
      this.remarkFormItem.remark = item.remark;
    },
    addRemark() {
      let param = new FormData();
      param.set("connector", this.filter.connector );
      param.set("id", this.remarkFormItem.id );
      param.set("remark", this.remarkFormItem.remark );
      RequestUtils.request(conf.addReviewRemark(), param)
      .then(() => {            
        this.remarkFormItem.remark = '';
        this.addRemarkModal = false;
        this.request();
      })
    },
    tempDown() {
      downloadFile(conf.importTemp(), '差评模板.xlsx');
    },
    // 预览图片
    previewImg(url) {
      this.preview.previewImgurl = url;
      this.preview.previewModal = true;
    },
    // 设置跟进人员
    setOperater() {
      let operateIds = this.tableSelectionId();
      if (operateIds.length == 0) {
        return this.$Message.error('请先选择评论!');
      }
      let param = new FormData();
      param.set("connector", this.filter.connector );
      param.set("operate_id", this.track_user_id );
      param.set("ids", this.tableSelectionId().join(',') );
      RequestUtils.request(conf.setCommentOperater(), param)
      .then(() => {            
        this.trackUserModal = false;
        this.$refs.selection.selectAll(false);
        this.request();
      })
      
    },
    // 复制客户资料
    buyer_info (item) {
      if (this.filter.connector == 'lazada') {
        if (!item.store_id) {
          return this.$Message.error('未找到该订单的所属店铺!');
        }
        let self = this;
        let param = new FormData();
        param.set("order_id", item.ordersn);
        param.set("store_id", item.store_id);

        const msg = this.$Message.loading({
            content: 'Loading...',
            duration: 0
        });

        RequestUtils.request(conf.getOrder(), param)
        .then(function (data) {
          setTimeout(msg, 0);
          let skus = new Array();
          for (let i=0; i<data.items.length; i++) {
            skus.push(data.items[i].sku);
          }
          let copyValue = data.address_shipping.address1+'\n';
          copyValue += data.address_shipping.address3+'\n';
          copyValue += data.address_shipping.address4+'\n';
          copyValue += data.address_shipping.address5+'\n'+'\n';
          copyValue += data.order_number+'\n';
          copyValue += data.customer_first_name+'\n';
          copyValue += data.address_shipping.phone+'\n';
          copyValue += data.created_at+'\n';
          copyValue += item.store.name+'\n';
          copyValue += skus.join(',')+'\n';

          self.$copyText(copyValue).then(() => {
            self.$Message.success('已成功复制到剪切板');
          }).catch(() => {
            self.$Message.error('复制失败');
          })
        })
      }
    },
    // 打开聊天
    openSession(row) {
      this.$store.commit("lazada/openSession", {
        buyer_id: row.buyer_id,
        store_id: row.store_id
      });
    },
    // 删除差评
    del(row) {
      let param = new FormData();
      param.set("connector", this.filter.connector );
      param.set("ids", row.id );
      RequestUtils.request(conf.reviewDel(), param)
      .then(() => {
        this.request();
      })
    }
  },
  created() {
    this.getStoreList()
    this.getUserList()
    this.getTraceUser()
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.product-item {
  display:flex;
  padding: 5px 0px;

  .item-image {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .item-wrap {
    padding-left: 10px;

    .item-title {
      max-width: 150px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap; 
      font-weight:bold;
    }
  }
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;
      flex: 1;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }
}

.remark-trace {
  display: flex;
  padding-left: 10rem;
  height: 400px;
  overflow: scroll;

  .date-line {
    list-style: none;
    margin-right: 1rem;

    .date-item {
      height: 100px;
      width: 111px;
    }
  }
}
</style>
